import React, {FC, useState, useEffect} from "react";
import { API_URL, APPLICATION } from "../env";
import {  useTask } from '../stateManagement/context';
import {
    ComponentTypeID,
    IAdequacy, IAssessmentSettings, IControlMeasureAssessment,
    ICriticalHazards,
    IFailureModeAssessment,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import {
    Checkbox,
    Chip,
    Collapse, IconButton,
    MenuItem,
    Select,
    Table, TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip
} from "@material-ui/core";
import {WarningChip} from "./reasonably_practicable_tests";
import Comments from "./comments";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";


interface IFailureModeProps {
    failure_mode: IProjectFailureMode
    risk_assessment: ICriticalHazards
    initial_failure_mode_assessment: IFailureModeAssessment
    settings: IAssessmentSettings
    updateFailureModeAssessment: (failure_mode_assessment: IFailureModeAssessment) => void;
}



export const Confidence = (h: ICriticalHazards, key: keyof ICriticalHazards, name?:string) => {
        if (!h[key])
            return WarningChip(name?name:"undefined")

    let level =h[key]

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1
    let label = "undefined"

    if (level === 1) {
        bcolor = "rgba(0,176,80," + alpha + ")";
        color = "rgb(0,0,0)";
        label = "Very Strong";
    }
    if (level === 2) {
        bcolor = "rgba(206,238,208," + alpha + ")";
        color = "rgb(48,104,33)";
        label = "Strong";
    }
    if (level === 3) {
        bcolor = "rgba(252,236,166," + alpha + ")";
        color = "rgb(152,96,34)";
        label = "Weak";
    }
    if (level > 3) {
        bcolor = "rgba(251,84,81," + alpha + ")";
        color = "rgb(104,4,0)";
        label = "Very Weak";
    }

    return (
            <Tooltip title={label}>
                <Chip
                    size="small"
                    label={name? name : label}
                    color="primary"
                    style={{backgroundColor: bcolor, color: color}}
                />
            </Tooltip>
    )
}

const FailureMode: FC<IFailureModeProps> = ({   failure_mode,
                                                risk_assessment,
                                                initial_failure_mode_assessment,
                                                settings, 
                                                updateFailureModeAssessment}) => {

    const [failure_mode_assessment, setFailureModeAssessment] = useState<IFailureModeAssessment>(initial_failure_mode_assessment);

    const [open, setOpen] = useState(false);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    const risk_estimate_table  = {
        table_data:[
            ["Adequate", "Adequate", "Adequate"],
            ["Data Gap", "Data Gap", "Data Gap"],
            ["Substantive Data Gap", "Substantive Data Gap", "Substantive Data Gap"],
            ["Inadequate", "Inadequate", "Inadequate"]],
        cols:["Low","Medium","High","Very High"],
        rows:["Level of detail and status of risk assessment", "Engineering Inputs", "Consequences"],
        color:{
            red:["Inadequate", "Substantive Data Gap"],
            orange:["Data Gap"],
            green:["Adequate"],
            darkgreen:[]
        }
    }

    const existing_risk_level  = {
        table_data:[
            ["Very Weak", "Weak", "Strong", "Very Strong", "Very Strong"],
            ["Very Weak", "Very Weak", "Weak", "Strong", "Very Strong"],
            ["Very Weak", "Very Weak", "Very Weak", "Weak", "Strong"],
            ["Very Weak", "Very Weak", "Very Weak", "Very Weak", "Weak"],
        ],
        cols:["Low","Medium","High","Very High"],
        rows:["Above Threshold", "0-0.5", "0.5-1.0", "1.0-2.0", ">2.0"],
        color: {
            red: ["Very Weak"],
            orange: ["Weak"],
            green: ["Strong"],
            darkgreen: ["Very Strong"]
        }
    }

    const renderMatrix = (rows : string[], cols : string[], table_data : string[][],
                          color:{red:string[],
                                orange:string[],
                                green:string[],
                                darkgreen:string[]},
                          selected?:{row:number, col:number}[]) => {

        return (
            <>
        <TableRow>
            <TableCell></TableCell>
            {rows.map(
                (ad, index) => {
                    return (
                        <TableCell><b>{ad}</b>  </TableCell>
                    ) }
            )}
        </TableRow>
        {cols.map(
            (ad, index) => {
                return (
                    <TableRow>
                        <TableCell> <b>{ad}</b></TableCell>
                        {table_data[index].map( (e, index_i) => {
                            let found = false
                            let found1 = false

                            let row_index = -1

                            if (selected)
                                selected.map( s => {
                                    if (s.col == index_i){
                                        found1 = true
                                    }

                                    if (s.row == index) {
                                        found = true
                                    }

                                })

                            let style = {}



                            if (found && found1) {
                                style = ({ ...style, fontWeight:  "bold",
                                    outline: "4px solid black",
                                    outlineOffset: "-4px"})
                            }


                            style = ({ ...style,
                                backgroundColor:  "rgb(196,196,196)",
                                color: "#535353"
                            })
                            if (color.darkgreen.includes(e)) {
                                style = ({ ...style,
                                    backgroundColor:  "rgb(0,176,80)",
                                    color: "rgb(0,0,0)"
                                })
                            }

                            if (color.green.includes(e)) {
                                style = ({ ...style,
                                    backgroundColor:  "rgb(206,238,208)",
                                    color: "rgb(48,104,33)"
                                })
                            }
                            if (color.orange.includes(e)) {
                                style = ({ ...style,
                                    backgroundColor:  "rgb(252,236,166)",
                                    color: "rgb(152,96,34)"
                                })
                            }
                            if (color.red.includes(e)) {
                                style = ({ ...style,
                                    backgroundColor:  "rgb(251,84,81)",
                                    color: "rgb(104,4,0)"
                                })
                            }
                            return <TableCell style={style}>
                                {e}
                            </TableCell>
                        })}
                    </TableRow>

                )}
        )}
            </>)
    }
    const get_col = (threshold: number, value: number):number  =>  {
        let factors = [
            100,
            10,
            2,
            1
        ]
        let index = 4
        for (let i =0; i < factors.length; i++)
        {
            if (threshold < value / factors[i]){
                break
            }
            index -= 1
        }
        return index
    }

    return (<>
            <TableRow>
            <TableCell>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </TableCell>
                <TableCell>{failure_mode.failure_mode?.name}</TableCell>
                <TableCell align="right">{risk_assessment.max_annual_failure_probability.toExponential(1)}</TableCell>
                <TableCell align="right">{risk_assessment.max_societal_risk.toExponential(1)}</TableCell>
                <TableCell align="right">{(risk_assessment.contribution_to_societal_risk * 100).toFixed(1)+"%"}</TableCell>
                <TableCell align="right">{(risk_assessment.max_individual_risk !== 0) ? (risk_assessment.max_individual_risk.toExponential(1)): "-"}</TableCell>
                <TableCell align="right">{(risk_assessment.contribution_to_individual_risk* 100) ? (risk_assessment.contribution_to_individual_risk* 100).toFixed(2)+"%" : "-"}</TableCell>
                <TableCell>
                    <Select
                        style={{fontSize:"11pt"}}
                        value={failure_mode_assessment.uncertainty}
                        disabled={!write_access}
                        onChange={ (event) => {
                            let value = parseInt(event.target.value as string)
                            if (value) {
                                let c = {...failure_mode_assessment}
                                c.uncertainty = value
                                setFailureModeAssessment(c)
                                updateFailureModeAssessment(c)
                            }
                        }}>
                        <MenuItem value={1}>low</MenuItem>
                        <MenuItem value={2}>medium</MenuItem>
                        <MenuItem value={3}>high</MenuItem>
                        <MenuItem value={4}>very high</MenuItem>
                    </Select>

                </TableCell>
                <TableCell>
                    <Chip
                        size="small"
                        label={risk_assessment.critical ? "Yes": "No"}
                        color="primary"
                        style={{
                            backgroundColor: risk_assessment.critical ? "rgb(251,84,81)": "rgb(206,238,208)",
                            color:risk_assessment.critical ? "rgb(104,4,0)": "rgb(48,104,33)"}}
                    />
                    </TableCell>
                <TableCell>
                    <Checkbox
                        checked={failure_mode_assessment.consider}
                        disabled={!write_access}
                        color="primary"
                        onChange={() => {
                            let c = {...failure_mode_assessment}
                            c.consider = !failure_mode_assessment.consider
                            setFailureModeAssessment(c)
                            updateFailureModeAssessment(c)
                        }}
                    />
                </TableCell>
                <TableCell>{Confidence(risk_assessment, "societal_confidence_id")}</TableCell>
                <TableCell>{Confidence(risk_assessment, "individual_confidence_id")}</TableCell>
                <TableCell>{failure_mode.id && <Comments parent_uuid={failure_mode.id} type_id={ComponentTypeID.CriticalFailureMode}/>}</TableCell>
            </TableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}colSpan={1}/>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell align={"center"} colSpan={4}><b>Risk Estimates Inputs</b></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {renderMatrix(
                                risk_estimate_table.rows,
                                risk_estimate_table.cols,
                                risk_estimate_table.table_data,
                                risk_estimate_table.color)}
                        </TableBody>

                    </Table>
                </Collapse>
            </TableCell>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}></TableCell>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}></TableCell>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                {APPLICATION === "SFAIRP" && <TableCell align={"center"} colSpan={6}><b>Existing Risk Level Relative to the Safety Threshold</b></TableCell> }
                                {APPLICATION === "ALARP" && <TableCell align={"center"} colSpan={6}><b>Existing Risk Level Relative to the Limit of Tolerability</b></TableCell>}                        
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {renderMatrix(
                                existing_risk_level.rows,
                                existing_risk_level.cols,
                                existing_risk_level.table_data,
                                existing_risk_level.color,
                            [{row: (failure_mode_assessment.uncertainty || 0) - 1, col:get_col(risk_assessment.max_societal_risk, settings.safety_threshold_societal)},
                                {row: (failure_mode_assessment.uncertainty || 0) - 1, col:get_col(risk_assessment.max_individual_risk, settings.safety_threshold_individual)},
                            ])}

                        </TableBody>

                    </Table>

                </Collapse>
            </TableCell>
        </TableRow>
        </>
    )

}

export default FailureMode;
